"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumber = exports.isNullOrUndef = void 0;
function isNullOrUndef(value) {
    return value === null || value === undefined;
}
exports.isNullOrUndef = isNullOrUndef;
function isNumber(value, { min, max } = {}) {
    if (!(typeof value === 'number')) {
        return false;
    }
    if (isNumber(min) && value < min) {
        return false;
    }
    if (isNumber(max) && value > max) {
        return false;
    }
    return true;
}
exports.isNumber = isNumber;
